// extracted by mini-css-extract-plugin
export default {"heading":"addresses_heading__rjhXc","addBtn":"addresses_addBtn__I+NWy"};